import "../accordion.js";
import "../labeledTextInput.js";
import "../data-view.js";
import {CalendarClassSelector} from "../cal-class-selector.js";
import { LabeledTextInput } from "../labeledTextInput.js";
import { ModalDebugLog } from "../modals/modalDebugLog.js";
import { RadioButtons } from "../radiobuttons.js";

export class Settings {

   constructor(app) {

      this.app = app;
      this.dm = app.dm;
      this.tab = document.querySelector('.main-item[tab-name="settings"]');


      // Accordion vorbereiten
      this.tab.querySelectorAll('.section').accordion({
         closeOtherParent: this.tab,
         onOpening: async (button) => { this.update(button.dataset.panel); }
      });

      //this.txtLoginShort = new LabeledTextInput('#settings-user-short', { labelText: 'Benutzername'});
      //this.txtLoginPwd   = new LabeledTextInput('#settings-user-pwd', { labelText: 'Passwort'});

      this.txtPwdOld = new LabeledTextInput('#pwdOld', { labelText: 'Altes Passwort'});
      this.txtPwdNew1 = new LabeledTextInput('#pwdNew1', { labelText: 'Neues Passwort'});
      this.txtPwdNew2 = new LabeledTextInput('#pwdNew2', { labelText: 'Neues Passwort'});

      this.txtEmail = new LabeledTextInput('#settings-user-email', { labelText: 'Emailadresse'});


      // Einstellungsfenster: Klick auf 'Abmelden'
      this.tab.querySelector('.logout').addEventListener('click', () => this.logout());

      document.querySelector('#email-save').addEventListener('click', () => this.saveEmail());

      document.querySelectorAll('.settings .txt-settings').addEventListener('keyup', (event) => {
         if (event.keyCode === 13) this.save();
      });

      // Passwort ändern
      document.querySelector('#btn-change-pwd').addEventListener('click', (event) => {
         let old  = this.txtPwdOld.getValue();
         let new1 = this.txtPwdNew1.getValue();
         let new2 = this.txtPwdNew2.getValue();
         if (new1 != new2) {
            logger.error("Die eingegebenen neuen Passwörter sind nicht identisch.");
            toast.alert("Die eingegebenen neuen Passwörter sind nicht identisch.", { duration: 8000 });
         }
         else {
            this.dm.changePassword(old, new1)
            .then(response => {
               toast.message(response.notes.join('<br>'));
               this.load(true);
               this.txtPwdOld.setValue('');
               this.txtPwdNew1.setValue('');
               this.txtPwdNew2.setValue('');
            })
            .catch(e => {
               logger.error(e);
               toast.alert(e, { duration: 8000 });

            });
         }
      });

      this.elUpdateInfo = this.tab.querySelector('.update-info');
      this.elUpdateButton = this.tab.querySelector('.update');


      this.elUpdateButton.addEventListener('click', () => {
         localStorage.setItem('refreshDatabaseOnInit', true);         
         this.app.serviceWorkerRegistration.update().then(reg => {
         });
      });

      this.tab.querySelector('.open-console').addEventListener('click', () => {
         document.querySelector('.console').removeAttribute('hidden');
      });

      let elBtnDebugLog = this.tab.querySelector('.debug-log');
      elBtnDebugLog.addEventListener('click', () => {
         new ModalDebugLog(this.app, this.app.dm);
      });      

      this.tab.querySelector('.send-debug-info').addEventListener('click', () => {
         /*
         this.dm.getLocalDatabase()
         .then(database => {
            this.dm.sinRequest({ action: 'debug-log-save', type: 'databases', localDatabase: database, localStorage: this.dm.getLocalStorage() }, false, false)
            .then(data => toast.message('Debug-Informationen wurden gesendet.'));
         });
         */
      });        

      this.sliderCalFontSize = document.getElementById("slider-cal-font-size");
      this.sliderCalDayWidth = document.getElementById("slider-cal-day-width");
      this.sliderCalDayHeight = document.getElementById("slider-cal-day-height");
      this.sliderCalDayColumns = document.getElementById("slider-cal-day-columns");

      this.sliderCalFontSize.oninput = (event) => this.updateCalDayPreview();
      this.sliderCalDayWidth.oninput = (event) => this.updateCalDayPreview();
      this.sliderCalDayHeight.oninput = (event) => this.updateCalDayPreview();
      this.sliderCalDayColumns.oninput = (event) => this.updateCalDayPreview();

      let calSettings = this.dm.getCalendarSettings();
      this.sliderCalFontSize.value = calSettings.fontSize;
      this.sliderCalDayWidth.value = calSettings.dayWidth;
      this.sliderCalDayHeight.value = calSettings.dayHeight;
      this.sliderCalDayColumns.value = calSettings.dayColumns;

      this.myClassesSelector = new CalendarClassSelector({
         showMy: false,
         onChange: () => this.dm.saveMyClasses(this.myClassesSelector.getSelected())
      }, this.dm);

      // Sichtbar für
      this.permissionPupils = new RadioButtons('permission-pupils-default', {
         onSelect: (value) => {
            this.dm.clientSettings.set('classRegister.defaults.permissionPupils', value, true);
         }},
         [
               { label: "keine SuS",      value: "NONE" },
               { label: "abwesende SuS",  value: "PUPILS_ABSENT" },
               { label: "alle SuS",       value: "PUPILS_OF_COURSE" }
         ]
      );
      this.tab.querySelector('.classreg-settings .settings-item .content').prepend(this.permissionPupils.getElement());

      this.permissionTeachers = new RadioButtons('permission-teachers-default', {
         onSelect: (value) => {
            this.dm.clientSettings.set('classRegister.defaults.permissionTeachers', value, true);
         }},
         [
               { label: "nur ich",              value: "NONE" },
               { label: "Lehrer dieser Klasse", value: "TEACHERS_OF_CLASS" },
               { label: "alle Lehrer",          value: "TEACHERS_ALL" }
         ]
      );
      this.tab.querySelector('.classreg-settings .settings-item .content').prepend(this.permissionTeachers.getElement());


   }

   logout() {
      let clientId = localStorage.getItem('clientId');
      let timeout  = localStorage.getItem('timeout');
      this.dm.sinRequest({ action: 'usr-delete-auth-token', 'client-id': clientId });
      localStorage.clear();
      localStorage.setItem('clientId', clientId);
      localStorage.setItem('timeout', timeout);
      this.dm.dropDatabase();
      window.location.reload(true);
   }

   update(sectionName) {

      if      (sectionName === 'user-data') this.loadUserData();
      else if (sectionName === 'cal-settings') this.updateCalDayPreview();
      else if (sectionName === 'app-info') this.loadAppInfo();
      else if (sectionName === 'email') this.loadEmail();
      else if (sectionName === 'classreg-settings') this.loadClassRegister();

   }

   loadClassRegister() {

      this.permissionPupils.setValue('NONE', false);
      this.permissionPupils.setValue(this.dm.clientSettings.get('classRegister.defaults.permissionPupils', 'NONE'), false);
      this.permissionTeachers.setValue('NONE', false);
      this.permissionTeachers.setValue(this.dm.clientSettings.get('classRegister.defaults.permissionTeachers', 'NONE'), false);

      this.elCbxClassregContentVisible  = this.tab.querySelector('#settings-classreg-content-visible');
      this.elCbxClassregHomeworkVisible = this.tab.querySelector('#settings-classreg-homework-visible');
      this.elCbxClassregNotesVisible    = this.tab.querySelector('#settings-classreg-notes-visible');

      this.elCbxClassregContentVisible.checked  = this.dm.clientSettings.get('classRegister.defaults.contentVisible', false);
      this.elCbxClassregHomeworkVisible.checked = this.dm.clientSettings.get('classRegister.defaults.homeworkVisible', false);
      this.elCbxClassregNotesVisible.checked    = this.dm.clientSettings.get('classRegister.defaults.notesVisible', false);

      [this.elCbxClassregContentVisible, this.elCbxClassregHomeworkVisible, this.elCbxClassregNotesVisible].forEach(elCbx => elCbx.onchange = () => {
         this.dm.clientSettings.set('classRegister.defaults.contentVisible', this.elCbxClassregContentVisible.checked, false);
         this.dm.clientSettings.set('classRegister.defaults.homeworkVisible', this.elCbxClassregHomeworkVisible.checked, false);
         this.dm.clientSettings.set('classRegister.defaults.notesVisible', this.elCbxClassregNotesVisible.checked, true);
      });

      this.tab.querySelector('#settings-classreg-autocorrect').checked = this.dm.clientSettings.get('classRegister.autocorrect', false);
      this.tab.querySelector('#settings-classreg-autocorrect').onchange = (event) => {
         this.dm.clientSettings.set('classRegister.autocorrect', event.target.checked, true);
      };

   }

   loadEmail() {
      ///?///
      let user = this.dm.getUserSelf();
      this.txtEmail.setValue(user.email ? user.email : '');
   }

   loadAppInfo() {

      this.elUpdateInfo.innerHTML = "Es wurde kein Update gefunden.";
      //this.elUpdateButton.disabled = 'true';

      this.tab.querySelector('.version span').innerHTML = localStorage.getItem('appVersion');

      let elBtnDebugLog = this.tab.querySelector('.debug-log');
      elBtnDebugLog.style.display = this.dm.getUserSelf().short === 'LEI' ? 'inline-block' : 'none';

      /*
      navigator.serviceWorker.getRegistrations().then(registrations => {
         registrations.forEach(v => {
            if (v.waiting && v.waiting.constructor.name === 'ServiceWorker') {
               this.newWorker = v.waiting;
               this.elUpdateInfo.innerHTML = "Ein Update ist verfügbar.";
               this.elUpdateButton.disabled = '';
            }
         });
      });
      */
   }

   async loadUserData() {

      let userData = this.dm.getUserSelf();

      let showData = [
         { label: 'Typ', value: { teacher: 'Lehrer', pupil: 'Schüler'}[userData.type] },
         { label: 'Benutzername', value: userData.short },
         { label: 'Nachname', value: userData.lastName },
         { label: 'Vorname', value: userData.firstName },
      ];
      if (userData.type === 'pupil') showData.push({ label: 'Klasse', value: userData.class.name });

      dataView('.user-data.data-view', showData);

      if (userData.type === 'teacher') {
         let year = this.dm.getCurrentYear();
         this.myClassesSelector.setClasses(year.classes, this.dm.getMyClasses());
         let classSelect = this.tab.querySelector('.my-classes');
         classSelect.empty();
         classSelect.append(this.myClassesSelector.getHtmlElement());
         this.tab.querySelector('.my-classes').style.display = 'block';
      }
      else {
         this.tab.querySelector('.my-classes').style.display = 'none';
      }

      let outerPanel = this.tab.querySelector('.user-data + .accordion-panel');
      outerPanel.style.maxHeight = outerPanel.scrollHeight + "px";

   }

   updateCalDayPreview() {

      let outerPanel = this.tab.querySelector('.cal-settings + .accordion-panel');
      outerPanel.style.maxHeight = 'unset';
      this.tab.querySelector('.appointment').style.fontSize = this.sliderCalFontSize.value / 100 + 'rem';
      this.tab.querySelector('.calendar-day').style.width = this.sliderCalDayWidth.value + 'px';
      this.tab.querySelector('.calendar-day').style.height = this.sliderCalDayHeight.value + 'px';
      this.tab.querySelector('.calendar-day .dimensions').innerHTML = this.sliderCalDayWidth.value + 'x' + this.sliderCalDayHeight.value;
      this.tab.querySelector('.cal-day-preview .columns').innerHTML = this.sliderCalDayColumns.value > 0 ?
         `Es werden mindestens ${this.sliderCalDayColumns.value} Tag(e) nebeneinander dargestellt.` :
         "Die Anzahl der nebeneinander angezeigten Tage wird automatisch festgelegt.";

      outerPanel.style.maxHeight = outerPanel.scrollHeight + "px";
      this.dm.saveCalendarSettings({
         fontSize: this.sliderCalFontSize.value,
         dayWidth: this.sliderCalDayWidth.value,
         dayHeight: this.sliderCalDayHeight.value,
         dayColumns: parseInt(this.sliderCalDayColumns.value)
      });


   }

   // Einstellungen laden
   load(loadData) {

      const user = this.dm.getUserSelf();

      this.tab.querySelector('.user-description').innerText = "Angemeldeter Benutzer: " + user.firstName + ' ' + user.lastName + ' (' + user.short + ')';

      
      if (user.type === 'teacher') {
         this.tab.querySelectorAll('.data-button[user-type="pupil"]').forEach(btn => btn.style.display = 'none');
      }
      else {
         this.tab.querySelectorAll('.data-button[user-type="teacher"]').forEach(btn => btn.style.display = 'none');
      }

      this.loadGeneralSettings();

   }

   loadGeneralSettings() {

      // Schriftgröße auswählen
      const elFontSize = this.tab.querySelector('.app-settings .select-font-size')
      elFontSize.value = this.dm.getFontSize();
      elFontSize.onchange = (event) => {
         this.dm.setFontSize(event.currentTarget.value);
         this.app.selectFontSize();
      }

      // Themes auswählen
      const elSelect = this.tab.querySelector('.app-settings .select-theme');
      elSelect.empty();
      this.dm.getThemes().then(themes => {
         const themeNames = [];
         for (let theme of themes) {
            const cntUsers = (theme.id !== 1 && theme.cntUsers > 20 ? '🔥' : '') + theme.cntUsers;
            const elTheme = HTMLElement.createFromHTML(`'<option value="${theme.name}">${cntUsers} ${theme.name} (${theme.details})</option>`);
            elSelect.appendChild(elTheme);
            themeNames.push(theme.name);
         }
         if (!themeNames.includes(this.dm.getCurrentThemeName())) this.dm.setCurrentThemeName('Standard');
         elSelect.value = this.dm.getCurrentThemeName();
      });


      //this.tab.querySelector('.app-settings .select-theme').value = this.dm.getTheme();
      //document.querySelector('body').classList.add(this.dm.getTheme());

      this.tab.querySelector('.app-settings .select-theme').onchange = (event) => {
         this.dm.setCurrentThemeName(event.currentTarget.value);
         this.app.selectTheme();
      };

      /*
      // Checkbox 'Sync on Init'
      const cbxSyncOnInit = this.tab.querySelector('#cbx-sync-on-init');
      cbxSyncOnInit.checked = this.dm.getSyncOnInit();
      cbxSyncOnInit.addEventListener('change',  (event) => {
         this.dm.setSyncOnInit(event.target.checked);
      });
      */

      // Checkbox 'Timeout'
      const cbxTimeout = this.tab.querySelector('#cbx-timeout');
      cbxTimeout.checked = localStorage.getItem('timeout') === 'true';
      cbxTimeout.addEventListener('change',  (event) => {
         localStorage.setItem('timeout', event.target.checked);
      });


      /*
      // Checkbox 'Klassenbucheinträge Standardeinstellung: Sichtbar für Schüler'
      const cbxClassregVisibleForPupils = this.tab.querySelector('#cbx-classreg-default-pupil-visible');

      cbxClassregVisibleForPupils.checked = this.dm.getClassregDefaultVisibleForPupils();
      cbxClassregVisibleForPupils.addEventListener('change',  (event) => {
         this.dm.setClassregDefaultVisibleForPupils(event.target.checked);
      });
      */


      // Checkbox 'debug mode'
      const cbxDebugMode = this.tab.querySelector('#cbx-debug-mode');
      cbxDebugMode.checked = this.dm.getDebugMode();
      cbxDebugMode.addEventListener('change',  (event) => {
         this.dm.setDebugMode(event.target.checked);
      });
   

   }


   async requestNewPassword() {

      try {
         let email = await this.dm.requestNewPassword();
         toast.message("Eine Email zum Zurücksetzen des Passworts wurde an die von Ihnen hinterlegte Emailadresse (" + email + ") gesendet.");
      }
      catch(e) {
         logger.error(e);
         toast.alert(e, { duration: 8000 });
      }

   }

   async saveEmail() {

      try {
         let user = this.dm.getUserSelf();
         await this.dm.setUserEmail(this.txtEmail.getValue());
         user.email = this.txtEmail.getValue();
         this.dm.setupUser(user);
         toast.message("Emailadresse gespeichert.");
      }
      catch(e) {
         logger.error(e);
         toast.alert(e, { duration: 8000 });
      }

   }

}
